/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { ActionButton, Typography } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { enterpriseColors } from '../../style/colors';

export namespace TaskCard {
  export interface Props {
    id: string;
    taskName: string;
    buttonLabel: string;
    onOpenTask: () => void;
  }
}

const styles = StyleSheet.create({
  wrapper: {
    padding: '14px 24px',
    maxWidth: 600,
    border: `1px solid ${enterpriseColors.NEUTRAL_200}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 6,
    backgroundColor: enterpriseColors.WHITE,
  },
  taskName: {
    ...Typography.Roboto(),
    color: enterpriseColors.NEUTRAL_800,
    fontSize: 14,
    fontWeight: 500,
  },
  buttonWrapper: {
    minWidth: 120,
  },
});

export const TaskCard: React.FC<TaskCard.Props> = ({ id, onOpenTask, taskName, buttonLabel }) => {
  return (
    <div data-it={`task-${id}-wrapper`} className={css(styles.wrapper)}>
      <span data-it={`task-${id}-name`} className={css(styles.taskName)}>
        {taskName}
      </span>
      <div className={css(styles.buttonWrapper)}>
        <ActionButton
          data-dd-privacy="allow"
          data-it={`task-${id}-action`}
          btnSize="md"
          label={buttonLabel}
          type="button"
          onClick={onOpenTask}
          isFullWidth={true}
        />
      </div>
    </div>
  );
};
